export default {
  dev: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
    _4aPCUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5-4a.html', // 测试
    _feedback: 'https://mapeconsolesit.midea.com/feedback/index.html', //意见反馈
    _4aUrl: 'https://signinuat.midea.com/login?service=',   // 测试
    defaultMobileUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5.html'
  },
  sit: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
    _4aPCUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5-4a.html', // 测试
    _feedback: 'https://mapeconsolesit.midea.com/feedback/index.html', //意见反馈
    _4aUrl: 'https://signinuat.midea.com/login?service=',   // 测试
    defaultMobileUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5.html',

  },
  uat: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
  },
  prod: {
    host: "https://uom.midea.com/midea-uom-gateway/uom-server/",
    _4aPCUrl: 'https://im.midea.com/download/pcv5-4a.html',  // 生产
    _feedback: 'https://mapnew5.midea.com/feedback/index.html', //意见反馈(生产环境)
    _4aUrl: 'https://signin.midea.com/login?service=',
    defaultMobileUrl: 'https://im.midea.com/download/pcv5.html',
  },
  apis: [
    {
      // PC端获取下载地址
      name: "getPcUrl",
      config: {
        url: "api/sysParam/list/MeiXin_downloadPage_Link",
        method: "get",
      },
    },
    {
      name: "getMobileUrl",
      config: {
        url: "api/sysParam/listPost/MeiXin_downloadPage_Link",
        method: "post",
      },
    },
    {
      name: "getVPNUrl",
      config: {
        url: "api/sysParam/list/VPN_downloadPage_Link",
        method: "get",
      },
    },
  ]
};